<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)" />
    </ul>
    <div class="list_time" @click="openTime">
      <span>查询时间</span>
      <span class="time_icon">
        {{ zsStartTime }} 至 {{ zsEndtTime }}
        <van-icon name="arrow" />
      </span>
    </div>
    <van-tabs style="margin: 0px 4px;" v-model="active" title-active-color="#3C9ECF" swipeable @click="reportQuery">
      <van-tab title="检验报告">
        <ul v-if="jyShow" class="jy_list">
          <li v-for="item in jyList" :key="item.labNo" @click="go(1, item)">
            <div class="jy_left">
              <van-icon name="newspaper-o" />
            </div>
            <div class="jy_right">
              <span class="name">{{ item.checkTypeName }}</span>
              <span class="kstime">
                <span>{{ item.applyDept }}</span>
                <span>{{ item.checkTime }}</span>
              </span>
            </div>
          </li>
        </ul>
        <van-empty v-if="!jyShow"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无报告"
        />
      </van-tab>
      <van-tab title="检查报告">
        <ul v-if="jcShow" class="jy_list">
          <li v-for="item in jcList" :key="item.labNo" @click="go(2, item)">
            <div class="jy_left">
              <van-icon name="newspaper-o" />
            </div>
            <div class="jy_right">
              <span class="name">{{ item.checkTypeName }}</span>
              <span class="kstime">
                <span>{{ item.applyDept }}</span>
                <span>{{ item.checkTime }}</span>
              </span>
            </div>
          </li>
        </ul>
        <van-empty v-if="!jcShow"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无报告"
        />
      </van-tab>
    </van-tabs>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
    <van-popup class="lttc" v-model="showTime" round position="top">
      <div style="color: #666;font-size: 14px;">查询时间</div>
      <div class="time_sel">
        <input class="input_class" type="text" v-model="startTime" @click="showSart = true" />
        <span class="xg">/</span>
        <input class="input_class" type="text" v-model="endtTime" @click="showEnd = true" />
      </div>
      <div class="btns">
        <van-button @click="showTime = false" type="default">取消</van-button>
        <van-button @click="qdbtn" type="info">确定</van-button>
      </div>
    </van-popup>
    <van-calendar
      :default-date="defaultDate"
      v-model="showSart"
      @confirm="onConfirmStart"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-calendar
      v-model="showEnd"
      @confirm="onConfirmEnd"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, getCkLabResult } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      showNation: false,
      showTime: false,
      showSart: false,
      showEnd: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      active: 0,
      minDate: "",
      maxDate: "",
      defaultDate: "",
      startTime: "",
      endtTime: "",
      zsStartTime: "",
      zsEndtTime: "",
      jyShow: false,
      jyList: [],
      jcShow: false,
      jcList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == "/" || from.path == "/index"){
        vm.getVisitinfos();
      } else {
      }
    })
  },
  created() {
    this.getDate();
  },
  mounted() {
    // this.getVisitinfos();
  },
  activated() {
    // this.getDate();
    // this.getVisitinfos();
  },
  methods: {
    // 获取时间
    getDate(){
      this.minDate = new Date(this.$moment(new Date()).subtract(1, 'year').format("YYYY-MM-DD"));
      this.maxDate = new Date(this.$moment(new Date()).format("YYYY-MM-DD"));
      this.defaultDate = new Date(this.$moment(new Date()).subtract(1, 'months').format("YYYY-MM-DD"));
      this.startTime = this.$moment(this.defaultDate).format("YYYY-MM-DD");
      this.endtTime = this.$moment(this.maxDate).format("YYYY-MM-DD");
      this.zsStartTime = this.startTime;
      this.zsEndtTime = this.endtTime;
    },
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.reportQuery();
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.reportQuery();
      this.Toast("切换成功");
    },
    // 报告查询
    async reportQuery(){
      let map = {
        patientID: this.selectdata.patientId,
        // patientID: this.active == 0?188:114329,
        startDate: this.zsStartTime,
        stopDate: this.zsEndtTime,
        type: this.active == 0?1:2,
        userId: "7148"
      };
      let res = await getCkLabResult(map);
      if(res.data.message == "操作成功"){
        if(this.active == 0){
          this.jyList = res.data.obj.resultData;
          this.jyShow = true;
        } else {
          this.jcList = res.data.obj.resultData;
          this.jcShow = true;
        }
      } else {
        if(this.active == 0){
          this.jyShow = false;
        } else {
          this.jcShow = false;
        }
      }
    },
    // 查看电子卡
    cardbtn(item) {
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 打开日期选择弹窗
    openTime(){
      this.showTime = true;
      this.startTime = this.zsStartTime;
      this.endtTime = this.zsEndtTime;
    },
    // 查询日期
    qdbtn(){
      this.showTime = false;
      this.zsStartTime = this.startTime;
      this.zsEndtTime = this.endtTime;
      this.reportQuery();
    },
    // 报告详情
    go(num, item){
      if(num == 1){
        sessionStorage.setItem("report",JSON.stringify(item));
        this.$router.push("/textReportetails"); // 检验报告
      } else if(num == 2) {
        sessionStorage.setItem("report",JSON.stringify(item));
        this.$router.push("/screenReportetails"); // 检查报告
      }
    },
    onConfirmStart(data) {
      this.startTime = this.$moment(data).format("YYYY-MM-DD");
      this.showSart = false;
    },
    onConfirmEnd(data) {
      this.endtTime = this.$moment(data).format("YYYY-MM-DD");
      this.showEnd = false;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  /deep/ .van-tabs {
    border-top: 1px solid #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    .van-tab__text--ellipsis {
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__line {
      background-color: #3c9ecf !important;
    }
  }
  .current_user {
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #e6f5fc;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    > li {
      > span {
        letter-spacing: 0px;
      }
    }
    > li:nth-child(2) {
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  /deep/ .list_time {
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #e6f5fc;
    border-radius: 6px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .time_icon {
      position: relative;
      display: flex;
      align-items: center;
      .van-icon {
        margin-left: 4px;
        position: relative;
        top: 1px;
        font-weight: bold;
      }
    }
  }
  /deep/ .lttc {
    padding-top: 10px;
    > div {
      padding: 0px 10px;
    }
    .time_sel {
      // text-align: center;
      position: relative;
      margin: 10px 0px;
      .input_class {
        text-align: center;
        caret-color: transparent;
        border: 1px solid #666;
        width: 140px;
        height: 30px;
      }
      .xg {
        position: relative;
        top: 4px;
        color: #666;
        margin: 0px 10px;
        font-size: 22px;
      }
    }
    .btns {
      padding: 0px;
      border: 1px solid #999;
      height: 40px;
      display: flex;
      button {
        font-size: 14px;
        letter-spacing: 10px;
        flex: 1;
      }
    }
  }
  /deep/ .jy_list {
    display: flex;
    flex-flow: column nowrap;
    padding: 0px 16px;
    background: #fff;
    > li {
      padding: 16px 0px;
      border-bottom: 1px solid #ddd;
      display: flex;
      flex-flow: row nowrap;
      font-size: 16px;
      align-items: center;
      .jy_left{
        width: 16%;
        .van-icon{
          background: #FFD700;
          border-radius: 50%;
          color: white;
          width: 46px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          font-size: 30px;
        }
      }
      .jy_right{
        // flex: 1;
        width: 84%;
        display: flex;
        flex-flow: column nowrap;
        .name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
        }
        .kstime {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          font-size: 12px;
          margin-top: 10px;
          color: #666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/Report/report.vue